// Touch screens have no real hover: a tap's emulated mouseenter would stick a
// preview until the next tap. So hover-driven previews (alternative chips and
// cards on Trip detail, stop/leg highlights on the Journey detail map) are
// wired only where the primary pointer can hover.
export const CAN_HOVER = typeof window !== 'undefined'
  && typeof window.matchMedia === 'function'
  && window.matchMedia('(hover: hover)').matches;
